<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span v-if="activeTab == '0'" class="masge">当前共有{{ total }}个保养等级</span>
      </div>

      <div class="header">
        <div class="left" v-if="activeTab == '0'">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>
        </div>
        <div class="right" v-if="activeTab == '0'">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <!-- <el-tabs v-model="activeTab" @tab-click="tabClick">
        <el-tab-pane v-for="item in tabs" :key="item.id" :label="item.name" :name="item.id"></el-tab-pane>
      </el-tabs> -->
      <el-tabs v-model="activeTab" @tab-click="tabClick" stretch>
        <el-tab-pane v-for="item in tabs" :key="item.id" :name="item.id">
          <template slot="label">
            <span style="margin: 0 10px"> {{ item.name }} </span>
          </template>
        </el-tab-pane>
      </el-tabs>

      <template v-if="activeTab == '0'">
        <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%;margin-top:10px" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template>
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column prop="desc" show-overflow-tooltip label="描述"></el-table-column>
          <el-table-column prop="remark" show-overflow-tooltip label="备注"></el-table-column>
          <el-table-column prop="operation" label="操作" show-overflow-tooltip width="110">
            <template slot-scope="scope">
              <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" class="color-blue" v-preventReClick @click="handleUpdate(scope.row)">编辑</el-button>
              <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" class="margin-left20 color-blue" v-preventReClick @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog :title="title + this.route.menuName" :visible.sync="open" :center="true" width="500px" :before-close="cancel" :close-on-click-modal="false">
          <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
            <el-row>
              <el-col :span="24">
                <el-form-item label="名称" prop="name">
                  <el-input v-model="form.name" placeholder="请填写名称"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="描述" prop="desc">
                  <el-input v-model="form.desc" placeholder="请填写描述" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注" prop="remark">
                  <el-input v-model="form.remark" placeholder="请填写备注" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer" style="">
            <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
            <my-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</my-button>
          </div>
        </el-dialog>
      </template>

      <SecondTable v-if="activeTab == '1'" :categoryName="'分类'" :type="3" :showHead="false"></SecondTable>
    </div>
    <div v-if="activeTab == '0'" class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  SaveMaintainLevel,
  RemoveMaintainLevels,
  GetMaintainLevels,
} from "@/api";
import SecondTable from "@/views/components/secondCategoryTable/content";
// import NormalTable from '@/views/components/normalCategoryTable'
import GetDataMixin from "@/mixin/getData-mixin";
export default {
  components: {
    SecondTable,
    // NormalTable
  },
  mixins: [GetDataMixin],
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,

      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      // 列表多选
      multiple: true,
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      tabs: [
        { id: "0", name: "保养等级" },
        { id: "1", name: "保养项目" },
      ],
      activeTab: "0",
    };
  },
  props: {},
  methods: {
    handleSelectionChange (selection) {
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      GetMaintainLevels(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.title = "新建";
      this.resetForm();
    },
    // 编辑
    handleUpdate (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "编辑";
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveMaintainLevel(this.form).then((res) => {
          this.open = false;
          this.$my_message(`执行成功`, "success");
          this.getData();
        });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        desc: "",
        remark: "",
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 取消编辑部门
    cancel () {
      this.$my_confirm("确认要中断当前操作吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.open = false;
        })
        .catch(() => { });
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("确认要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveMaintainLevels({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    tabClick (tab) {
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 200px;
  // margin-bottom: 10px;
}
</style>
